import { Spin } from 'antd';
import moment from 'moment';
import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    ResponsiveContainer,
    Tooltip
} from "recharts";
import { colors, StrokeColorsChart } from '../../Utils/constants';


const staticData = [
    {
        name: "Page A",
        uv: 1000,
        pv: 1000,
        amt: 1000
    },
    {
        name: "Page B",
        uv: 4000,
        pv: 2400,
        amt: 2400
    },
    {
        name: "Page C",
        uv: 4000,
        pv: 2400,
        amt: 2400
    },
    {
        name: "Page D",
        uv: 4000,
        pv: 2400,
        amt: 2400
    },
    {
        name: "Page E",
        uv: 4000,
        pv: 2400,
        amt: 2400
    },
    {
        name: "Page F",
        uv: 4000,
        pv: 2400,
        amt: 2400
    },
    {
        name: "Page G",
        uv: 3490,
        pv: 4300,
        amt: 2100
    }
];

const toolTipStyles = {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '10px'
}

function Chart({ data = [] }) {

    const { currentChart, chartMachines } = useSelector(state => state.kpis)
    // console.log(currentChart, "asdasdasdasd", chartMachines)
    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                currentChart == 'All' ?
                    <div style={toolTipStyles}>
                        <p className="intro">Time: {moment(label).format('hh:mm:ss a')}</p>
                        <p className="intro">Date: {moment(label).format('MMMM Do YYYY')}</p>
                        <p className="intro">Machines:</p>
                        {
                            payload?.map((data, i) => (
                                <h4 key={i} style={{ color: colors[i] }}>{(data?.dataKey).replace('_Machine', '')}: {Math.round(data?.value).toFixed(2)}</h4>
                            ))
                        }
                    </div> :
                    <div style={toolTipStyles}>
                        <p className="intro">Time: {moment(label).format('hh:mm a')}</p>
                        <p className="intro">Date: {moment(label).format('MMMM Do YYYY')}</p>
                        <p className="intro">Selected Machine:</p>
                        <p className="intro">{(payload[0].dataKey).replace('_Machine', '')} : {Math.round(payload[0]?.value).toFixed(2)}</p>
                    </div>
            );
        }
    };

    const strokeColors = {
        BlowMold: "#006400",
        Filler: "#7FFF00",
        Preform: "#8A2BE2",
        Labeller: "#00FFFF",
        Palletizer: "#D2691E",
        Variopac: "#00008B"
    }

    return (
        <ResponsiveContainer width={"98%"} height={"100%"}>
            <LineChart
                data={data || staticData}
                margin={{
                    top: 5,
                    right: 0,
                    left: -20,
                    // bottom: -20
                }}
            >
                <Tooltip content={CustomTooltip} />
                <XAxis interval={199} dataKey={'time'} tickFormatter={(value) => moment(value).format('hh:mm a')} />
                {
                    currentChart == 'All' ?
                        chartMachines?.map((machine, i) => (
                            <>
                                <React.Fragment key={i}>
                                    <YAxis dataKey={machine + '_Machine'} />
                                    <Line
                                        type="monotone"
                                        dataKey={machine + '_Machine'}
                                        stroke={colors[i]}
                                        strokeWidth={1.5}
                                        // activeDot={{ r: 8 }} 
                                        dot={false}
                                    />
                                </ React.Fragment>
                            </>
                        )) :
                        <>
                            <Line
                                type="monotone"
                                dataKey={currentChart + '_Machine'}
                                stroke={strokeColors[currentChart]}
                                strokeWidth={1.5}
                                // activeDot={{ r: 8 }} 
                                dot={false}
                            />
                            <YAxis dataKey={currentChart + '_Machine'} />
                        </>
                }

            </LineChart>
        </ResponsiveContainer>
    )
}

export default Chart

